import { FC } from 'react';
import { Link } from 'react-router-dom';
import { Edit } from 'jbc-front/components/icons';
import { Headding, Item, Panel } from '@/components/PrimaryPanel';
import { Grid } from '@/components/ui/Grid';
import { Dd, Dl, Dt } from '@/components/ui/DefinitionList';
import { displayFormat } from '@/components/utils/formatter';
import { ViewProps } from './ViewProps';

export const Title: FC<ViewProps> = ({ report, editLink }) => {
  return (
    <Panel>
      <Link to={`${editLink}#title`}>
        <Headding icon={<Edit icon={16} />}>報告書の名称</Headding>
      </Link>
      <Item>
        <Grid>
          <Dl>
            <Dt>報告書の名称</Dt>
            <Dd>{displayFormat(report.title)}</Dd>
          </Dl>
        </Grid>
      </Item>
    </Panel>
  );
};
